import { reactive } from 'vue'
import { useData } from './useData'
import { getNoticeInfo } from '@/service/common'
import { jumpUrl } from '@/utils/jump'

/** 公告数据 */
export const noticeState = reactive({
  text: '',
  url: ''
})

/** 初始化公告数据 */
export function updateNoticeInfo() {
  useData(getNoticeInfo, {
    loading: false,
    success(data) {
      const { noticeContent, noticeUrl } = data || {}
      noticeState.text = noticeContent
      noticeState.url = noticeUrl
    }
  })
}

export function jumpNotice() {
  jumpUrl(noticeState?.url, {
    webview: true,
    functionName: 'jumpNotice',
    data: { noticeState }
  })
}
